export const headerData = [
  { title: 'Trade', route: 'swap' },
  // { title: 'Bridge', route: 'bridge' },
  { title: 'Pools', route: 'pools' },
  // { title: 'Earn', route: 'earn' },
  { title: 'Info', route: 'info' }
  // { title: 'Doc', route: 'https://soswap-finance.gitbook.io/bswap' }
]
